/**
 * The Legal Agent portal keeps its state in the URL query. RouterContext's `setQuery`
 * replaces the whole query string, so every writer serializes the full parsed query
 * with one field changed: `setQuery(serializeLegalAgentQuery({ ...query, actor }))`.
 */
export type LegalAgentActor = 'agent' | 'user';

export type LegalAgentQuery = {
  actor: LegalAgentActor | null;
};

const ACTORS: LegalAgentActor[] = ['agent', 'user'];

export function parseLegalAgentQuery(val: Record<string, unknown>): LegalAgentQuery {
  return {
    actor: ACTORS.find((actor) => actor === val.actor) ?? null,
  };
}

export function serializeLegalAgentQuery(query: LegalAgentQuery): Record<string, unknown> {
  return query.actor ? { actor: query.actor } : {};
}

export function isLegalAgentQueryFiltered(query: LegalAgentQuery): boolean {
  return query.actor !== null;
}
